import { Select, Slider } from "antd";

export default function MenuComponent({
  dataMapa,
  setDataMapa,
  tipoMapa,
  setTipoMapa,
  regiones,
  setRegionSelect,
  setAnnoSelect,
  annoSelect,
  handleAnno,
  dataProyectada,
}) {

  // Define los valores específicos para el Slider
  const sliderValues = [2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2020, 2021, 2022, 2023];
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "10px",
        alignItems: "center",
        padding: "10px",
      }}
    >
      Categoría: 
      <Select
        defaultValue="Total nuevos predios"
        style={{
          width: "100%",
          maxWidth: "280px",
        }}
        onChange={(val) => setDataMapa(val)}
        options={[
          {
            value: "Total nuevos predios",
            label: "Total nuevos predios",
          },
          {
            value: "Nuevos predios cada 1000 hogares",
            label: "Nuevos predios cada 1000 hogares",
          },
        ]}
      />

      Visualización:
      <Select
        defaultValue="País"
        style={{
          width: "100%",
          maxWidth: "100px",
        }}
        onChange={(val) => setTipoMapa(val)}
        options={[
          {
            value: "País",
            label: "País",
          },
          {
            value: "Regional",
            label: "Regional",
          },
        ]}
      />

      <Select
        defaultValue={regiones[0]}
        style={{
          width: "100%",
          maxWidth: "250px",
        }}
        onChange={(val) => setRegionSelect(val)}
        options={regiones.map((el) => {
          return { value: el, label: el };
        })}
        disabled={tipoMapa === "País"}
      />

      <div
        style={{
          width: "100%",
          maxWidth: "800px",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "12px",
          alignItems: "center",
        }}
      >

        <Slider
          value_com={annoSelect}
          defaultValue={annoSelect}
          min={sliderValues[0]} // Establece el valor mínimo como el primer valor en el arreglo
          max={sliderValues[sliderValues.length - 1]} // Establece el valor máximo como el último valor en el arreglo
          step={null} // Establece el step como null para permitir cualquier valor en el arreglo
          marks={sliderValues.reduce((acc, value_com) => {
            acc[value_com] = value_com; // Crea marcas con los valores del arreglo
            return acc;
          }, {})}
          onChange={(val) => handleAnno(val, dataProyectada)}
          style={{
            width: "100%",
            maxWidth: "2000px",
          }}
        />
      </div>
    </div>
  );
}